import {React, Component, Container, _} from 'utils';
import {ApplyStore, Creators, FairStore, JobStore} from 'model';
import {ajaxLoader, profileIcon} from 'resources';
import './fastapplybutton.less';

class FastApplyInput extends Component {

	render()
	{
		let {name, label, required, value, onChange, error, errorMessage, additionalInfo, type} = this.props;
		let errorClass = (error) ? 'error' : '';
		let inputType = (type) ? type : 'text';
		return (
			<div className={"form-group " + errorClass}>
				<label>{label + (required ? '*' : '')}</label>
				<input className='form-control' type={inputType} name={name} value={value} onChange={onChange}/>
				{error ? <div>{errorMessage}</div> : null}
				<div>{additionalInfo}</div>
			</div>
		);
	}
}

class FastApplyError extends Component {

	render()
	{
		let {message} = this.props;

		if (!message)
		{
			return null;
		}

		return (
			<div className="fast-apply-error">{message}</div>
		);
	}
}

class ModalTitle extends Component {

	render()
	{
		let applicationTypeText = <div className="col-12 sub-title">{_('Application type')}</div>;
		if (this.props.loading || this.props.hideType)
		{
			applicationTypeText = null;
		}

		return (
			<div>
				<div className="row no-gutters">
					<div className="col-12 title">{_('Application')}</div>
					{applicationTypeText}
					<div className="col-12 sub-title">{this.props.loading}</div>
				</div>
				<button type="button" className="close" data-dismiss="modal" aria-label="Close" name="apply-success-ok"
						onClick={this.submit}>
					<span aria-hidden="true">&times;</span>
				</button>
			</div>
		);
	}
}

class FastApplyButton extends Component {

	static getStores()
	{
		return [JobStore, ApplyStore, FairStore];
	}

	static calculateState()
	{
		let fairStoreState = FairStore.getState();
		let fairStoreLoader = fairStoreState.loaderUrl;
		let fastApplySiteLogoUrl = fairStoreState.fastApplySiteLogoUrl;
		let loaderUrl = fairStoreLoader ? fairStoreLoader : ajaxLoader;

		let applyState = ApplyStore.getState();
		return Object.assign(
			{},
			{applyButtonShow: JobStore.getSelectedJobs().length > 0},
			applyState,
			{
				loaderUrl,
				fastApplySiteLogoUrl,
				tosLink: fairStoreState.tosLink,
			},
		);
	}

	change = (event) =>
	{
		Creators.changeFastApply(event.target.name, event.target.value);
	};

	upload = (event) =>
	{
		Creators.uploadFastApply(event.target.name, event.target.files[0]);
	};

	clearData = (event) =>
	{
		event.target.parentElement.querySelector('.document-upload').value = '';
		Creators.clearFastApplyData();
	};

	emailCheck = () =>
	{
		let {email} = this.state;
		let rexp = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/i;
		if (!email || !rexp.test(email))
		{
			Creators.changeFastApply('emailError', true);
			console.log('email error: ' + email);
			return 0;
		}
		return 1;
	};

	passwordCheck = () =>
	{
		let {password} = this.state;
		if (!password || password.length < 3)
		{
			Creators.changeFastApply('passwordError', true);
			console.log('password error: ' + password);
			return 0;
		}
		return 1;
	};

	firstNameCheck = () =>
	{
		let {firstName} = this.state;
		if (!firstName || firstName.length < 2 || firstName.match(/\d/i))
		{
			Creators.changeFastApply('firstNameError', true);
			console.log('first name error: ' + firstName);
			return 0;
		}
		return 1;
	};

	lastNameCheck = () =>
	{
		let {lastName} = this.state;
		if (!lastName || lastName.length < 2 || lastName.match(/\d/i))
		{
			Creators.changeFastApply('lastNameError', true);
			console.log('last name error: ' + lastName);
			return 0;
		}
		return 1;
	};

	handleLoaderImageError = () => {
		this.setState({loaderUrl: ajaxLoader});
	};

	phoneCheck = () =>
	{
		let {phone} = this.state;
		if (!phone || phone.length < 2 || phone.match(/[a-z]/i))
		{
			Creators.changeFastApply('phoneError', true);
			console.log('phone number error: ' + phone);
			return 0;
		}
		return 1;
	};

	submit = (event) =>
	{
		if (event.target.name === 'apply-anon')
		{
			if (this.emailCheck() & this.firstNameCheck() & this.lastNameCheck() & this.phoneCheck())
			{
				let {fileName, fileContent, documentSure} = this.state;
				if ((!fileName || !fileContent) && !documentSure)
				{
					Creators.changeFastApply('documentSure', true);
				}
				else
				{
					Creators.fastApplyAnonSubmit();
				}
			}
		}
		else if (event.target.name === 'apply')
		{
			if (this.emailCheck() & this.passwordCheck())
			{
				let {fileName, fileContent, attachProfile, documentSure} = this.state;
				if ((!fileName || !fileContent) && !attachProfile && !documentSure)
				{
					Creators.changeFastApply('documentSure', true);
				}
				else
				{
					Creators.fastApplySubmit();
				}
			}
		}
		else if (event.target.name === 'apply-success-ok')
		{
			Creators.changeFastApply('showApplySuccess', false);
		}
	};

	render()
	{
		var {
			applyButtonShow, showApplySuccess, documentSure, firstName,
			lastName, phone, email, password, attachProfile, emailError,
			passwordError, firstNameError, lastNameError, phoneError,
			loading, applyError, loaderUrl, fastApplySiteLogoUrl,
			tosLink,
		} = this.state;

		let loadingElement = (loading) ? <img src={loaderUrl} alt={_('Loading')} onError={this.handleLoaderImageError}/> : null;
		let visibleClass = (loading) ? 'd-none' : 'd-block';

		let fastApplySiteLogoImage = fastApplySiteLogoUrl ? fastApplySiteLogoUrl : profileIcon;
		let fastApplySiteImg = <img src={fastApplySiteLogoImage} alt='fast-apply-site-logo'/>;

		var modalContent = null;

		let applyButton = (applyButtonShow) ? (
			<div className="row fast-apply-start" data-toggle="modal" data-target="#fast-apply-modal">
				{_('Apply')}
			</div>
		) : null;

		if (showApplySuccess)
		{
			modalContent = (
				<div className="modal-body">
					<p>{_('Application successful')}</p>
					<button type="button" name="apply-success-ok" className="btn btn-submit" data-dismiss="modal"
							aria-label="Close" onClick={this.submit}>{_('Ok')}
					</button>
				</div>
			);
		}
		else
		{
			var submitMessage = null;
			var submitText = _('Apply');

			if (emailError || passwordError)
			{
				submitMessage = (
					<p className="error">
						<div>{_('Application not sent')}</div>
						<div>{_('Fix errors')}</div>
					</p>
				);
			}
			else
			{
				if (documentSure)
				{
					submitMessage = <p>{_('Apply without documents?')}</p>;
					submitText = _('Yes, apply');
				}
			}

			modalContent = (
				<div className={"modal-body " + visibleClass}>
					<button className="btn btn-application collapsed" data-toggle="collapse"
							data-target="#collapseOne"
							aria-expanded="false"
							aria-controls="collapseOne" onClick={this.clearData}>
						<div className="btn-img"><img src={profileIcon} alt="profile"/></div>
						{_('Application without registration')}
					</button>
					<div id="collapseOne" className="collapse" aria-labelledby="headingOne" data-parent=".modal-body">
						<div className="card-body">
							<form className="application-form">
								<FastApplyError message={applyError}/>
								<FastApplyInput name={'firstName'} label={_('First name')} required={true}
												value={firstName} onChange={this.change} error={firstNameError}
												errorMessage={_('First name error')}/>
								<FastApplyInput name={'lastName'} label={_('Last name')} required={true}
												value={lastName} onChange={this.change} error={lastNameError}
												errorMessage={_('Last name error')}/>
								<FastApplyInput name={'email'} label={_('Email')} required={true} value={email}
												onChange={this.change} error={emailError}
												errorMessage={_('Email error')}/>
								<FastApplyInput name={'phone'} label={_('Phone')} required={true} value={phone}
												onChange={this.change} error={phoneError}
												errorMessage={_('Phone error')}
												additionalInfo={_('(+XXX) (X)XX XXXX XXX')}/>
								<div className="form-group">
									<label>{_('Document')}</label>
									<input className="form-control document-upload" type="file" name='file'
										   onChange={this.upload}/>
								</div>
								{submitMessage}
								<button type="button" name="apply-anon" className="btn btn-submit"
										onClick={this.submit}>
									{submitText}
								</button>
							</form>
						</div>
					</div>

					<button className="btn btn-application collapsed" data-toggle="collapse"
							data-target="#collapseTwo"
							aria-expanded="false"
							aria-controls="collapseTwo" onClick={this.clearData}>
						<div className="btn-img">{fastApplySiteImg}</div>
						{_('Application with profile')}
					</button>
					<div id="collapseTwo" className="collapse" aria-labelledby="headingTwo" data-parent=".modal-body">
						<div className="card-body">
							<form className="application-form">
								<FastApplyError message={applyError}/>
								<FastApplyInput name={'email'} label={_('Email')} required={true} value={email}
												onChange={this.change} error={emailError}
												errorMessage={_('Email error')}/>
								<FastApplyInput name={'password'} label={_('Password')} required={true}
												value={password} onChange={this.change} error={passwordError}
												type="password" errorMessage={_('Password error')}/>
								<div className="form-group">
									<label>{_('Document')}</label>
									<input className="form-control document-upload" type="file" name='file'
										   onChange={this.upload}/>
								</div>
								<div className="form-check">
									<label className="form-check-label" htmlFor="attach-profile">
										{_('Attach profile')}
									</label>
									<input className="form-check-input" id="attach-profile" name="attachProfile"
										   type="checkbox" value={1 - attachProfile} onChange={this.change}
										   checked={attachProfile == 1}/>
								</div>
								{submitMessage}
								<button type="button" name="apply" className="btn btn-submit"
										onClick={this.submit}>{submitText}</button>
							</form>
						</div>
					</div>
					{tosLink ? (
						<div className="tos-info">
							<span dangerouslySetInnerHTML={{__html: _('apply.tosLinkHtml', {tosLink})}}/>
						</div>
					) : null}
				</div>
			)
		}

		return (
			<div className="fast-apply-container">
				{applyButton}
				<div className="modal fade" id="fast-apply-modal" tabIndex="-1" role="dialog"
					 aria-labelledby="fast-apply-modal" aria-hidden="true">
					<div className="modal-dialog modal-dialog-centered modal-sm">
						<div className="modal-content">
							<ModalTitle loading={loadingElement} hideType={showApplySuccess}/>
							{modalContent}
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default Container.create(FastApplyButton);



// WEBPACK FOOTER //
// ./src/modules/components/fastapplybutton.js